import React from 'react'
import { map } from 'lodash'

export default({clinic, classes}) => {
  const socialLinks = clinic.socialMedia
  return (
    <React.Fragment>
      { 
        map(socialLinks, (social, ndx) => {
          return (
            <div className="flex-0 center" key={`social-${ndx}`}>
              <a href={social.url} target="_blank" rel="noreferrer">
                <img src={`/assets/images/social/${social.type}.svg`} className={classes} alt={`Eye Clinics of Seattle - ${clinic.name} - ${social.type}`} />
              </a>
            </div>
          )
        })
      }
    </React.Fragment>
  )
}